import './SubclientDropdown.scss'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select } from 'antd'
import ImageResources from "../../../layouts/commonComponent/components/ExternalResources/ImageResources";

const SubclientDropdown = ({ onChangeHandler, subclients, addClassSubClient = true }) => {
  const { t } = useTranslation()
  const { Option } = Select

    const getUrlPerson =(id) => {
        return  ('/getImageClientUser/0/' + id)
        //<img src={ apiConfig.url + '/../getImageClientUser/0/' + item.id } alt="" style={{ height: '15px' }} />
    }

  return (
      <div className={addClassSubClient ? "subclient-dropdown" : ""}>
          <label for="subclient-dropdown">Ejecutar consulta como: </label>
      <Select id="subclient-dropdown"
        onChange={ onChangeHandler }
        placeholder="Seleccionar empresa"
        >
        { subclients.map( (item, index) =>
            <Option className="subclient-option" value={ item.id } key={index}>
              <div className="subclient-option-inner">
                <figure className="subclient-logo">
                  <ImageResources url={getUrlPerson( item.id)}  styleResource={{ height: '15px' }}></ImageResources>
                </figure>
                <span className="subclient-name" style={{ paddingLeft: '10px' }}>{ item.name }</span>
              </div>
            </Option>
          )
        }
      </Select>
    </div>
  )
}
export default SubclientDropdown;
